import {
  Image,
  Linking,
  Platform,
  Pressable,
  StyleSheet,
  View,
} from "react-native";

import { getStoreLinks } from "~/utils/runtime-config";

const appStoreBadge = require("../../../assets/badges/app-store-colour.png");
const googlePlayBadge = require("../../../assets/badges/google-play-colour.png");

export function WebStoreBadges() {
  if (Platform.OS !== "web") return null;
  const storeLinks = getStoreLinks();
  if (!storeLinks.ios && !storeLinks.android) return null;

  return (
    <View style={stylesheet.badges}>
      {storeLinks.ios ? (
        <Pressable
          accessibilityRole="link"
          accessibilityLabel="Download on the App Store"
          onPress={() => void Linking.openURL(storeLinks.ios)}
        >
          <Image
            source={appStoreBadge}
            style={[stylesheet.badgeImage, stylesheet.appStoreBadge]}
            resizeMode="contain"
          />
        </Pressable>
      ) : null}
      {storeLinks.android ? (
        <Pressable
          accessibilityRole="link"
          accessibilityLabel="Get it on Google Play"
          onPress={() => void Linking.openURL(storeLinks.android)}
        >
          <Image
            source={googlePlayBadge}
            style={[stylesheet.badgeImage, stylesheet.googlePlayBadge]}
            resizeMode="contain"
          />
        </Pressable>
      ) : null}
    </View>
  );
}

const stylesheet = StyleSheet.create({
  badges: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    paddingHorizontal: 16,
  },
  badgeImage: {
    height: 45,
  },
  appStoreBadge: {
    width: 135,
  },
  googlePlayBadge: {
    width: 152,
  },
});
